import { render, staticRenderFns } from "./AssignmentsTeacher.vue?vue&type=template&id=559eebfd&scoped=true&"
import script from "./AssignmentsTeacher.vue?vue&type=script&lang=js&"
export * from "./AssignmentsTeacher.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentsTeacher.vue?vue&type=style&index=0&id=559eebfd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559eebfd",
  null
  
)

export default component.exports